import { Box, CircularProgress, Typography } from "@mui/material";

export default function StatAsyncContent({ error, loading, children }) {
  if (error) {
    return (
      <Typography color="error" variant="body2">
        Error: {error}
      </Typography>
    );
  }

  if (loading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", py: 6 }}>
        <CircularProgress />
      </Box>
    );
  }

  return children;
}
